<template>
<v-container v-if="permitted == false && permitted != null" class="pt-0" fluid>
  <v-dialog v-model="permitted_dialog" max-width="400px">
    <v-card>
      <v-card-text>
        <div class="text-center">
          <div class="title font-weight-light pt-2"><v-icon class="mr-1">mdi-shield-lock-outline</v-icon>Security Error</div>
          <p>{{message}}</p>
          <v-progress-circular
            :size="70"
            :width="2"
            :value="100"
            color="error"
            class="mb-4 mr-4"
          >
            <v-icon color="red" x-large>mdi-exclamation-thick</v-icon>
          </v-progress-circular>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</v-container>
<v-container v-else v-show="permitted != null" class="pt-0" fluid>
  <v-snackbar
    :value="showMessage()"
    multi-line
    color="#686868"
    top
    
  >
    {{message}}
  </v-snackbar>
  <v-card flat >
  <v-toolbar dense flat color="#2A353D">
    <v-toolbar-title class="white--text subtitle-1 font-weight-normal">Dividends</v-toolbar-title>
    <v-spacer/>
    <!-- <span class="white--text caption font-weight-normal">Transacting Currency: {{Currency[0].CurrencyName}}</span> -->
  </v-toolbar>
  </v-card>

  <v-data-table
    disable-pagination
    hide-default-footer
    :height="520"
    :headers="headers"
    :fixed-header="true"
    :items="confirmedDividends ? Dividends : Dividends.filter(a => a.CheckerID === 0)"
    sort-by="MakeDate"
    sort-desc
    :search="search"
    class="elevation-12 mt-2"
    @current-items="getFiltered"
  >

    <template v-slot:top >
      <v-form class="edit rounded-t-xl elevation-6" ref="form" v-model="valid" lazy-validation v-if="create">
        <v-toolbar dense flat color="#DBEFFA">
          <v-toolbar-title class="grey--text subtitle-1 font-weight-normal">New Dividend</v-toolbar-title>
          <v-spacer/>
        </v-toolbar>
        <v-row class="ml-1 mr-1">
          <v-col class="pb-0">
            <v-row class="mx-0">
              <v-col class="py-0 pl-0">
                <v-text-field
                  light dense filled
                  color="#2A353D"
                  label="Ref Code"
                  disabled
                ></v-text-field>                
              </v-col>
              <v-col class="py-0 pr-0">
                <v-select
                  filled dense
                  v-model="dividend.DividendTypeID"
                  :items="DividendTypes"
                  item-text="TypeName"
                  item-value="DividendTypeId"
                  placeholder="----"
                  :rules="TextFieldRules"
                  label="Dividend Type"
                ></v-select>
              </v-col>
            </v-row>
            <v-text-field
              light dense filled
              color="#2A353D"
              v-model="dividend.Amount"
              label="Amount/share"
              required type="number"
              :rules="TextFieldRules"
              placeholder="----"
            ></v-text-field>
            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              :return-value.sync="dividend.LastDateToRegister"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="dividend.LastDateToRegister"
                label="Last Date to Register"
                append-icon="mdi-calendar-month"
                readonly placeholder="--/--/--"
                :error-messages="LDTRerrors"
                :rules="TextFieldRules"
                dense filled color="#2A353D"
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
              </template>
              <v-date-picker color="#2A353D" v-model="dividend.LastDateToRegister" no-title scrollable>
              <v-spacer></v-spacer>
              <v-btn outlined small color="#2A353D" @click="menu = false">Cancel</v-btn>
              <v-btn outlined small color="#2A353D" @click="$refs.menu.save(dividend.LastDateToRegister)">OK</v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col class="pb-0">
            <v-select
              filled dense
              v-model="dividend.InstrumentID"
              :items="allCounters.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
              item-text="EquityCode"
              item-value="EquityID"
              placeholder="----"
              :rules="TextFieldRules"
              label="Instrument"
            ></v-select>
            <v-menu
              ref="menu_2"
              v-model="menu_2"
              :close-on-content-click="false"
              :return-value.sync="dividend.EffectiveDate"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="dividend.EffectiveDate"
                label="Payment Date"
                append-icon="mdi-calendar-month"
                readonly placeholder="--/--/--"
                :error-messages="EDerrors"
                :rules="DateRules"
                dense filled color="#2A353D"
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
              </template>
              <v-date-picker color="#2A353D" v-model="dividend.EffectiveDate" no-title scrollable>
              <v-spacer></v-spacer>
              <v-btn outlined small color="#2A353D" @click="menu_2 = false">Cancel</v-btn>
              <v-btn outlined small color="#2A353D" @click="$refs.menu_2.save(dividend.EffectiveDate)">OK</v-btn>
              </v-date-picker>
            </v-menu>
            <v-menu
              ref="menu_1"
              v-model="menu_1"
              :close-on-content-click="false"
              :return-value.sync="dividend.DeclarationDate"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="dividend.DeclarationDate"
                label="Declaration Date"
                append-icon="mdi-calendar-month"
                readonly placeholder="--/--/--"
                :error-messages="DDerrors"
                :rules="TextFieldRules"
                dense filled color="#2A353D"
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
              </template>
              <v-date-picker color="#2A353D" v-model="dividend.DeclarationDate" no-title scrollable>
              <v-spacer></v-spacer>
              <v-btn outlined small color="#2A353D" @click="menu_1 = false">Cancel</v-btn>
              <v-btn outlined small color="#2A353D" @click="$refs.menu_1.save(dividend.DeclarationDate)">OK</v-btn>
              </v-date-picker>
            </v-menu>
            <div class="text-right mb-4 pt-7">
              <v-btn class="white--text mr-3" small color="#2A353D" @click="closeCreate()">close</v-btn>
              <v-btn class="white--text" small color="#2A353D" :disabled="!valid" @click="createNew()">submit</v-btn>          
            </div>
          </v-col>
        </v-row>
        <v-divider class="mt-0"/>
      </v-form>

      <v-form class="edit rounded-t-xl elevation-6" ref="form" v-model="valid" lazy-validation v-if="edit">
        <v-toolbar dense flat color="#DBEFFA">
          <v-toolbar-title class="grey--text subtitle-1 font-weight-normal">View Dividend</v-toolbar-title>
          <v-spacer/>
        </v-toolbar>
        <v-row class="ml-1 mr-1">
          <v-col class="pb-0">
            <v-row class="mx-0">
              <v-col class="py-0 pl-0">
                <v-text-field
                  :value="currentDividend.CorporateEventCode"
                  light dense filled
                  color="#2A353D"
                  label="Ref Code"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col class="py-0 pr-0">
                <v-select
                  filled dense
                  v-model="currentDividend.DividendType"
                  :items="DividendTypes"
                  item-text="TypeName"
                  item-value="DividendTypeId"
                  placeholder="----"
                  label="Dividend Type"
                  readonly
                ></v-select>
              </v-col>
            </v-row>  

            <v-text-field
              light dense filled
              color="#2A353D"
              v-model="currentDividend.Amount"
              label="Amount/share"
              required readonly
              :rules="TextFieldRules"
              placeholder="----"
            ></v-text-field>
            <v-text-field
              v-model="currentDividend.LastDateToRegister"
              label="Last Date to Register"
              append-icon="mdi-calendar-month"
              readonly placeholder="--/--/--"
              :error-messages="editLDTRerrors"
              dense filled color="#2A353D"
            ></v-text-field>
          </v-col>
          <v-col class="pb-0">
            <v-select
              filled dense
              v-model="currentDividend.InstrumentID"
              :items="allCounters.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
              item-text="EquityCode"
              item-value="EquityID"
              placeholder="----"
              label="Instrument"
              readonly
            ></v-select>
            <v-text-field
              :value="currentDividend.EffectiveDate"
              label="Payment Date"
              append-icon="mdi-calendar-month"
              readonly
              dense filled color="#2A353D"
            ></v-text-field>
            <v-text-field
              v-model="currentDividend.DeclarationDate"
              label="Declaration Date"
              append-icon="mdi-calendar-month"
              readonly placeholder="--/--/--"
              :error-messages="editDDerrors"
              dense filled color="#2A353D"
            ></v-text-field>
            <div class="text-right mb-4 pt-7">
              <v-btn class="white--text mr-3" small color="#2A353D" @click="closeEdit()">close</v-btn>
            </div>
          </v-col>
        </v-row>
        <v-divider class="mt-0"/>
      </v-form>

      <!-- <v-dialog persistent v-model="dialog" max-width="500px">
        <v-card>
          <v-card-title>
            <span class="subtitle-1 grey--text">Choose a reason for this rejection</span>
          </v-card-title>

          <v-card-text>
            <v-select
              filled dense
              v-model="RejectionStatus"
              :items="allRejectionReasons"
              item-text="RejectionReasonDescription"
              item-value="RejectionReasonID"
              label="Rejection Reasons"
            ></v-select>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <div class="text-right mb-4">
              <v-btn class="white--text mr-3" small color="#2A353D" @click="close()">cancel</v-btn>
              <v-btn class="white--text mr-3" small color="#2A353D" v-if="RejectionStatus !== 0" @click="update(); close()">ok</v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog> -->

      <v-container row>

        <v-text-field
          class="ml-3"
          hide-details
          outlined
          placeholder="search..."
          v-model="search"
          append-icon="mdi-magnify"
          dense
        ></v-text-field>

        <v-spacer></v-spacer>

        <v-btn v-if="showCreateBtn == true" v-show="confirmedDividends" @click="showCreate(); closeEdit()" outlined small color="#2A353D" class="ml-2">
          Create New<v-icon small>mdi-plus</v-icon>
        </v-btn>
        <v-menu open-on-hover offset-y>
          <template v-slot:activator="{ on, attrs }">
          <v-btn v-on="on" v-bind="attrs" v-show="confirmedDividends" outlined small color="#2A353D" class="ml-2">
            EXPORT<v-icon class="ml-1" small>mdi-exit-to-app</v-icon>
          </v-btn>
          </template>
          <v-list dense>
          <v-list-item class="ma-0 pa-0">
            <v-btn @click="generatePDF(false)" text small color="#2A353D">
              <v-icon class="mr-1" small>mdi-file-pdf-box</v-icon>TO PDF
            </v-btn>
          </v-list-item>
          <v-list-item class="ma-0 pa-0">
            <v-btn text small color="#2A353D">
              <download-excel
                :data   = "CurrentDataset"
                type    = "xls"
                name    = "Dividends.xls">
  
                <v-icon class="mr-1" small>mdi-microsoft-excel</v-icon>TO EXCEL
              </download-excel>
            </v-btn>
          </v-list-item>
          <v-list-item class="ma-0 pa-0">
            <v-btn text small color="#2A353D">
              <download-excel
                :data   = "CurrentDataset"
                type    = "csv"
                name    = "Dividends.csv">
  
                <v-icon class="mr-1" small>mdi-file-document-outline</v-icon>TO CSV
              </download-excel>
            </v-btn>
          </v-list-item>
          </v-list>
        </v-menu>
        <v-btn @click="generatePDF(true)" v-show="confirmedDividends" outlined small color="#2A353D" class="ml-2" v-on="on">
          PRINT<v-icon class="ml-1" small>mdi-printer</v-icon>
        </v-btn>
        <!-- <v-menu open-on-hover offset-y>
          <template v-slot:activator="{ on, attrs }">
          <v-btn v-on="on" v-bind="attrs" outlined small color="#2A353D" class="ml-2">
            CURRENCY<v-icon class="ml-1">mdi-cash-check</v-icon>
          </v-btn>
          </template>
          <v-list dense>
          <v-list-item v-for="Currency in allCurrencies" :key="Currency.CurrencyID" @click="mapCurrency(Currency)">

          <v-list-item-title>
            {{ Currency.CurrencyName }}
          </v-list-item-title>

          </v-list-item>
          </v-list>
        </v-menu> -->
        <v-btn v-show="!confirmedDividends" @click="confirmedDividends = true" outlined small color="#2A353D" class="ml-2" v-on="on">
          ALL RECORDS<v-icon class="ml-1">mdi-playlist-check</v-icon>
        </v-btn>
      </v-container>
    </template>

    <!-- <template v-slot:item.status="{ item }">
      <v-chip small color="error" v-if="item.RejectionID !== 0">rejected</v-chip>
      <v-chip small color="warning" v-if="item.CheckerID == 0">pending</v-chip>
      <v-chip dark small color="#A6D879" v-if="item.CheckerID !== 0 && item.RejectionID == 0">confirmed</v-chip>
    </template> -->

    <template v-slot:item.actions="{ item }">
      <!-- <v-tooltip v-if="!confirmedDividends && item.CheckerID == 0" top>
        <template v-slot:activator="{ on }">
        <v-btn
          small @click="setActiveDividend(item, index); update()"
          outlined :disabled="showConfirmBtn == false || item.MakerID == currentUser.SecurityUserID || item.LastUserID == currentUser.SecurityUserID"
          v-on="on"
          color="#2A353D" class="mr-3"
        >
          confirm<v-icon class="ml-1" color="#2A353D">mdi-check-circle-outline</v-icon>
        </v-btn>
        </template>
        <span>confirm</span>
      </v-tooltip>
      <v-tooltip v-if="!confirmedDividends && item.CheckerID == 0" top>
        <template v-slot:activator="{ on }">
        <v-btn
          small @click="reject(); setActiveDividend(item, index)"
          outlined :disabled="showConfirmBtn == false || item.MakerID == currentUser.SecurityUserID || item.LastUserID == currentUser.SecurityUserID"
          v-on="on"
          color="#2A353D" class="mr-3"
        >
          reject<v-icon class="ml-1" color="#2A353D">mdi-close-circle-outline</v-icon>
        </v-btn>
        </template>
        <span>reject</span>
      </v-tooltip> -->
      <v-btn
        small outlined :disabled="edit || create"
        @click="setActiveDividend(item, index); showEdit()"
        color="#2A353D" class="mr-3"
      >
        <span>view</span>
      </v-btn>
    </template>

    <!-- <template v-slot:item.DepositMethodID="{ item }">
      {{getDepositMethodName(item.DepositMethodID)}}
    </template> -->

    <template v-slot:item.Amount="{ item }">
      {{Number(item.Amount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}
    </template>

    <template v-slot:item.InstrumentID="{ item }">
      {{allCounters.filter(a => a.EquityID == item.InstrumentID).map(a => a.EquityCode)[0]}}
    </template>

    <!-- <template v-slot:item.ValueDate="{ item }">
      {{ item.ValueDate | moment("DD MMM YYYY") }}
    </template>  -->

    <!-- <template v-slot:item.MakeDate="{ item }">
      {{ item.MakeDate | moment("DD MMMM YYYY") }}
    </template> -->

  </v-data-table>
</v-container>
</template>

<script>
import {mapGetters, mapActions} from "vuex";
import UserService from '../services/user.service';
import dealingService from '../services/dealing.service';
import transactionService from '../services/transaction.service';
import jsPDF from 'jspdf';
import 'jspdf-autotable'

export default {
  name: 'Dividends',

  data () {
    return {
      confirmedDividends: true,
      edit: false,
      create:false,
      permitted: null,
      permitted_dialog: true,
      message: '',
      menu: false,
      menu_1: false,
      dialog: false,
      search: '',
      valid: true,
      content: '',
      currentDividend: null,
      currentIndex: -1,
      CurrentDataset: [],
      headers: [
        { text: 'Instrument', value: 'InstrumentID', sortable: true },
        { text: 'Amount', value: 'Amount', sortable: true },
        { text: 'Payment Date', value: 'EffectiveDate', sortable: true },
        { text: 'Last Date To Register', value: 'LastDateToRegister', sortable: true },
        { text: 'Declaration Date', value: 'DeclarationDate', sortable: false },
        { value: 'actions', sortable: false, align: 'end' },
      ],
      DateRules: [
        v => !!v || 'field is required',
        v => (v >= this.currentSystemDate.DayDate) || 'Date cannot be before System Date',
      ],
      TextFieldRules: [
        v => !!v || 'field is required',
      ],
      dividend: {},
      CurrencyId: 0,
      RejectionStatus: 0,
      EDerrors: [],
      LDTRerrors: [],
      editLDTRerrors: [],
      DDerrors: [],
      editDDerrors: [],
      CorpEventTypes: [],
      DividendTypes: []
    }
  },

  computed: {
    ...mapGetters([
      "allCorpEvents",
      "allApplicationDefaults",
      "allClientAccounts",
      "allCounters",
      "allCurrencies",
      "allTransactionCodes",
      "allRejectionReasons",
      "currentSystemDate",
      "allConfirmationSettings"
    ]),
    currentUser() {
      return this.$store.state.auth.user;
    },
    Dividends() {
      return this.allCorpEvents.filter(a => a.EventType == 1);
    },
    // Currency() {
    //   return this.allCurrencies.filter(a => a.CurrencyID == this.CurrencyId);
    // },
    showEditBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 3024).map(r => r.AllowEdit)) == 1){
        return true
      }
    }
    return false;
    },

    showCreateBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 3024).map(r => r.AllowCreate)) == 1){
        return true
      }
    }
    return false;
    },

    showConfirmBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 3024).map(r => r.AllowConfirm)) == 1){
        return true
      }
    }
    return false;
    },

    CheckerID(){
      if(this.allConfirmationSettings.filter(a => a.FunctionID == 3024).map(a => a.Status)[0] == false){
        return this.currentUser.SecurityUserID
      } else {
        return 0
      }
    }
  },

  watch: {
    'dividend.EffectiveDate': {
      handler: function(newValue) {
        if(newValue != null && newValue != ''){
          var data = {
            Date: newValue,
          };

          dealingService.checkIsWeekendHoliday(data)
          .then(response => {
            this.EDerrors = response.data[0].Valid ? ['Date cannot be a weekend or holiday'] : []
          })
        }
      },
      deep: true
    },

    'dividend.LastDateToRegister': {
      handler: function(newValue) {
        if(newValue != null && newValue != ''){
          var data = {
            Date: newValue,
          };

          dealingService.checkIsWeekendHoliday(data)
          .then(response => {
            this.LDTRerrors = response.data[0].Valid ? ['Date cannot be a weekend or holiday'] : []
          })
        }
      },
      deep: true
    },

    'currentDividend.LastDateToRegister': {
      handler: function(newValue) {
        if(newValue != null && newValue != ''){
          var data = {
            Date: newValue,
          };

          dealingService.checkIsWeekendHoliday(data)
          .then(response => {
            this.editLDTRerrors = response.data[0].Valid ? ['Date cannot be a weekend or holiday'] : []
          })
        }
      },
      deep: true
    },

    'dividend.DeclarationDate': {
      handler: function(newValue) {
        if(newValue != null && newValue != ''){
          var data = {
            Date: newValue,
          };

          dealingService.checkIsWeekendHoliday(data)
          .then(response => {
            this.DDerrors = response.data[0].Valid ? ['Date cannot be a weekend or holiday'] : []
          })
        }
      },
      deep: true
    },

    'currentDividend.DeclarationDate': {
      handler: function(newValue) {
        if(newValue != null && newValue != ''){
          var data = {
            Date: newValue,
          };

          dealingService.checkIsWeekendHoliday(data)
          .then(response => {
            this.editDDerrors = response.data[0].Valid ? ['Date cannot be a weekend or holiday'] : []
          })
        }
      },
      deep: true
    }
  },

  created(){
    transactionService.getAllCorpEventTypesByID(1)
    .then(response => {
      this.CorpEventTypes = response.data
    });

    transactionService.retrieveDividendTypes(0)
    .then(response => {
      this.DividendTypes = response.data
      console.log("Dividend Types: " + JSON.stringify(this.DividendTypes))
    })
  },

  methods: {
    ...mapActions([
      "createCorpEvent",
      "updateCorpEvent",
      "deleteCorpEvent"
    ]),

    async createNew() {
      this.message = '';
      await this.validate();
      if(this.valid == true){
        this.dividend.MakerID = this.currentUser.SecurityUserID,
        // this.dividend.CheckerID = this.CheckerID,
        this.dividend.CheckerID = this.currentUser.SecurityUserID,
        this.dividend.LastUserID = this.currentUser.SecurityUserID,
        this.dividend.EventType = 1,

        this.createCorpEvent(this.dividend)
        .then(response =>{
          this.$socket.client.emit('socketreq', {
            commit: 'newCorpEvent',
            data: response.data
          });
          this.message = response.data.message
          this.closeCreate()
        },
        error => {
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
        })
      }
    },

    async update() {
      this.message = '';
      this.currentDividend.CheckerID = this.currentUser.SecurityUserID,
      this.currentDividend.LastUserID = this.currentUser.SecurityUserID,
      this.currentDividend.CheckDate = new Date(),
      this.currentDividend.updatedAt = new Date(),
      this.currentDividend.RejectionID = this.RejectionStatus,

      this.updateCorpEvent(this.currentDividend)
      .then(response => {
        this.$socket.client.emit('socketreq', {
          commit: 'updCorpEvent',
          data: this.currentDividend
        });
        
        this.message = response.data.message
        this.closeEdit()
      },
      error => {
      this.message =
        (error.response && error.response.data.message) ||
        error.message ||
        error.toString();
      })        
    },

    generatePDF(IsPrint) {
      const addFooters = doc => {
        const pageCount = doc.internal.getNumberOfPages()

        for (var i = 1; i <= pageCount; i++) {
          doc.setPage(i)
          // text is placed using x, y coordinates
          doc.setFontSize(10).text("Dividends", 0.5, 0.5);
          // create a line under heading 
          doc.setLineWidth(0.01).line(0.5, 0.6, 8.0, 0.6);
          doc.setLineWidth(0.01).line(0.5, 0.8, 8.0, 0.8);
          doc.setFontSize(6).text('Page ' + String(i) + ' of ' + String(pageCount), 4.3, 10.7, {
            align: 'center'
          })
        }
      }

      let doc = new jsPDF({
        orientation: "potrait",
        unit: "in",
        format: "letter"
      });

      doc.setFont('helvetica');
      doc.setFontSize(5);
      doc.autoTable({
        body: this.CurrentDataset,
        margin: { left: 0.5, top: 0.6 },
        styles: {overflow: 'linebreak',
                fontSize: 6},
        showHeader: 'everyPage',
        theme: 'plain'
      });
      addFooters(doc);
      if(IsPrint == true){
        doc.output('dataurlnewwindow');
      } else{
        doc.save('Dividends.pdf')
      }
    },

    // mapCurrency(currency) {
    //   return this.CurrencyId = currency.CurrencyID
    // },

    // getAccountName(id) {
    //   return this.allClientAccounts.filter(a => a.AccountID === id).map(a => a.tblclient.MajorName).toLocaleString() + ` ` + this.allClientAccounts.filter(a => a.AccountID === id).map(a => a.tblclient.Forename).toLocaleString() + ` - ` + this.allClientAccounts.filter(a => a.AccountID === id).map(a => a.AccountNumber).toLocaleString()
    // },

    // allowedDates: val => val <= new Date().toISOString().split('T')[0],

    // getDepositMethodName(id) {
    //   return this.allDepositMethods.filter(a => a.DepositMethodID === id).map(a => a.DepositMethodDescription).toLocaleString()
    // },

    getFiltered(current){
      this.CurrentDataset = current;
    },

    unconfirmed() {
      this.confirmedDividends = false
    },

    showEdit () {
      this.edit = true
    },

    closeEdit() {
      this.edit = false
    },

    showCreate () {
      this.create = true
    },

    closeCreate() {
      this.dividend = {};
      this.create = false
    },

    reject () {
      this.dialog = true
    },

    close () {
      this.dialog = false
      this.RejectionStatus = 0
    },

    showMessage(){
      if(this.message){
        return true
      } else {
        return false
      }
    },

    validate () {
      this.$refs.form.validate()
    },

    reset () {
      this.$refs.form.reset()
    },

    setActiveDividend (item, index) {
      this.currentDividend = item
      this.currentIndex = index;
    },
  },

  mounted () {
    UserService.isIncome().then(
      () => {
        this.permitted = true;
        this.message = '';
      },
      error => {
        this.permitted = false;
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
      }
    );
    this.$root.$on("unconfirmedDividends", () => {
      this.unconfirmed();
    });
  }
}
</script>

<style scoped>
.list {
  text-align: left;
  max-width: 750px;
  margin: auto;
}

.v-btn {
  outline: none
}

.edit {
  background-color: #DBEFFA;
}

.headline {
  color:white
}
</style>
